module.exports = __webpack_public_path__ + "static/media/photo 231.96154be8.jpg";